import { Flex, Heading } from '@televet/kibble-ui';
import React from 'react';
import { PetParentAvatar } from 'shared/components/Avatars';
import { useSidePanelSearch } from 'shared/components/SidePanel/components/SearchPanel/state/providers/SearchPanelProvider';
import { PetParentAvatarFragment } from 'shared/types/graphql';

export interface PetParentParticipantItemProps {
  clinicPetParent: PetParentAvatarFragment & { displayName?: string };
}

const PetParentParticipantItem = ({ clinicPetParent }: PetParentParticipantItemProps): JSX.Element => {
  const { viewClinicPetParent, setCurrentClinicPetId } = useSidePanelSearch();

  return (
    <Flex gap={2} alignItems="center">
      <PetParentAvatar
        size="sm"
        tooltipPlacement="top"
        clinicPetParent={clinicPetParent}
        onClick={(): void => {
          setCurrentClinicPetId('');
          viewClinicPetParent({
            clinicPetParentId: clinicPetParent.id || '',
            isPanelZIndexIncreased: true,
            clearConversationId: true,
          });
        }}
      />
      <Heading size="sm">
        {clinicPetParent.displayName ?? [clinicPetParent.firstName, clinicPetParent.lastName].join(' ').trim()}
      </Heading>
    </Flex>
  );
};

export default PetParentParticipantItem;
